import LMSDispatcher from "../../LMSDispatcher";
import { EventEmitter } from "events";

import * as CONSTANTS from "../../../utilities/Constants";
import INotificationData from "../../../models/shared/NotificationData";


interface INotificationState {
    state: INotificationData
}

class NotificationStore extends EventEmitter implements INotificationState {
    state: INotificationData;
    id: string;

    constructor() {

        super();

        this.state = {
            message: "",
            severity: ""
        };

        this.id = LMSDispatcher.register((e: any) => {
            switch (e.type) {
                case CONSTANTS.SHOW_NOTIFICATIONS:
                    Object.assign(this.state, e.payload);
                    this.emit('change', this.state);
                    break;
            }
        });
    }
}
const notificationStore = new NotificationStore();

export default notificationStore;
